import React, { useState, useEffect } from 'react';

// Function to format time in 12-hour format
const formatTime = (hour, minute) => {
  const formattedHour = hour % 12 || 12;
  const period = hour < 12 ? 'AM' : 'PM';
  return `${formattedHour}:${minute < 10 ? '0' + minute : minute} ${period}`;
};

// Function to convert to 24-hour format
const toMilitaryTime = (hour, minute) => {
  return `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`;
};

const timeSlots = [
  { start: { hour: 10, minute: 0 }, end: { hour: 10, minute: 30 } },
  { start: { hour: 10, minute: 30 }, end: { hour: 11, minute: 0 } },
  { start: { hour: 11, minute: 0 }, end: { hour: 11, minute: 30 } },
  { start: { hour: 11, minute: 30 }, end: { hour: 12, minute: 0 } },
  { start: { hour: 12, minute: 0 }, end: { hour: 12, minute: 30 } },
  { start: { hour: 12, minute: 30 }, end: { hour: 13, minute: 0 } },
  { start: { hour: 13, minute: 0 }, end: { hour: 13, minute: 30 } },
  { start: { hour: 13, minute: 30 }, end: { hour: 14, minute: 0 } },
  { start: { hour: 14, minute: 0 }, end: { hour: 14, minute: 30 } },
  { start: { hour: 14, minute: 30 }, end: { hour: 15, minute: 0 } },
  { start: { hour: 15, minute: 0 }, end: { hour: 15, minute: 30 } },
  { start: { hour: 15, minute: 30 }, end: { hour: 16, minute: 0 } },
  { start: { hour: 16, minute: 0 }, end: { hour: 16, minute: 30 } },
  { start: { hour: 16, minute: 30 }, end: { hour: 17, minute: 0 } },
  { start: { hour: 17, minute: 0 }, end: { hour: 17, minute: 30 } },
  { start: { hour: 17, minute: 30 }, end: { hour: 18, minute: 0 } },
  { start: { hour: 18, minute: 0 }, end: { hour: 18, minute: 30 } },
  { start: { hour: 18, minute: 30 }, end: { hour: 19, minute: 0 } },
  { start: { hour: 19, minute: 0 }, end: { hour: 19, minute: 30 } },
  { start: { hour: 19, minute: 30 }, end: { hour: 20, minute: 0 } },
];

const TimeBlockPage = () => {
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [disabledSlots, setDisabledSlots] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);  // Track highlighted slots from the API
  const userID = localStorage.getItem('userID');
  const [selectedHolidayUid, setSelectedHolidayUid] = useState(null); // Track selected holiday UID
  const [selectedHolidayUids, setSelectedHolidayUids] = useState([]); // Track multiple selected holiday UIDs

  const [holidaySlots, setHolidaySlots] = useState([]); // Add state for holiday slots
  const [bookedSlots, setBookedSlots] = useState([]); // HH:mm strings for existing appointments on selectedDate

  // Helper to delete a holiday time
  const deleteHolidayTimes = async (uids) => {
    if (selectedHolidayUids.length === 0) return;
    const uidParam = selectedHolidayUids.join(',');
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/MasterHolidayDelete?uid=${uidParam}`,
        { method: 'POST' }
      );
      if (!response.ok) throw new Error('Failed to delete holiday time');

      alert('Selected holiday time(s) deleted successfully.');
      fetchHolidaySlots(selectedDate); // Refresh holiday slots
    } catch (error) {
      console.error(error);
      alert('Error deleting holiday time(s)');
    }
  };

  // Fetch holiday slots and mark them gold
  const fetchHolidaySlots = async (date) => {
    const MasterId = localStorage.getItem('userID');
    const [year, month, day] = date.split('-');
    const currDate = `${month}-${year}`; // Format: MM-YYYY
    try {
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/GetHolidayDateTime?MasterId=${MasterId}&CurrDate=${currDate}`);
      const data = await response.json();
      // Extract LeaveDate in 'DD-MM-YYYY HH:mm' format and store UID
      setHolidaySlots(data.map(item => ({
        LeaveDate: item.LeaveDate,
        Uid: item.Uid
      })));
    } catch (error) {
      console.error('Error fetching holiday slots:', error);
    }
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    fetchDisabledSlots(date);
    fetchHolidaySlots(date); // Fetch holiday slots on date change
    fetchBookedSlots(date); // Fetch booked appointments so we cannot disable them
  };

  // Fetch the disabled slots from the API
  const fetchDisabledSlots = async (date) => {
    try {
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/getBT?ID=${userID}`);
      const data = await response.json();

      const formattedDate = new Date(date).toISOString().split('T')[0]; // Only the date part

      // Filter out disabled slots based on the selected date
      const disabled = data
        .filter((slot) => {
          const slotDate = new Date(slot.REC_DATE).toISOString().split('T')[0];
          return slotDate === formattedDate;
        })
        .map((slot) => slot.REC_DATE);

      setDisabledSlots(disabled);

      // Highlight slots from the API (reference pattern)
      const highlighted = data.map((slot) => {
        const date = new Date(slot.REC_DATE);
        return {
          day: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear(),
        };
      });
      setHighlightedDates(highlighted);
    } catch (error) {
      console.error('Error fetching disabled slots:', error);
    }
  };

  // Fetch booked appointments for the selected date so we prevent disabling them
  const fetchBookedSlots = async (date) => {
    if (!date) return;
    try {
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/getBD?ID=${userID}`);
      if (!response.ok) throw new Error('Failed to fetch booked appointments');
      const data = await response.json();
      const targetISO = new Date(date).toISOString().split('T')[0];
      const booked = data.filter(evt => {
        const evtDateISO = new Date(evt.REC_DATE).toISOString().split('T')[0];
        return evtDateISO === targetISO;
      }).map(evt => {
        const d = new Date(evt.REC_DATE);
        const hh = String(d.getHours()).padStart(2,'0');
        const mm = String(d.getMinutes()).padStart(2,'0');
        return `${hh}:${mm}`;
      });
      console.group('Booked Slots for date');
      console.log('Date:', date, 'Booked HH:mm:', booked);
      console.groupEnd();
      setBookedSlots(booked);
    } catch (err) {
      console.error('Error fetching booked slots:', err);
      setBookedSlots([]);
    }
  };

  const handleSlotToggle = (slot) => {
    setSelectedSlots((prevSlots) => {
      const isSelected = prevSlots.find((s) => s.start.hour === slot.start.hour && s.start.minute === slot.start.minute);
      if (isSelected) {
        return prevSlots.filter((s) => s.start.hour !== slot.start.hour || s.start.minute !== slot.start.minute);
      } else {
        return [...prevSlots, slot];
      }
    });
  };

  // Helper to POST disable times
  const postDisableTimes = async (dateTimes) => {
    const MasterId = Number(localStorage.getItem('userID'));
    const body = dateTimes.map(dt => ({
      MasterId,
      Type: 1,
      LeaveDate: dt // Format: 'YYYY-MM-DDTHH:mm:ss'
    }));
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/Booking/MasterHolidayUpdate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Failed to disable times');
      // Optionally refresh or notify user
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedDate || selectedSlots.length === 0) {
      alert('Please select a date and at least one time slot.');
      return;
    }

    const formattedDate = selectedDate;

    // Prepare dateTimes for postDisableTimes
    const dateTimes = selectedSlots.map((slot) => 
      `${formattedDate}T${toMilitaryTime(slot.start.hour, slot.start.minute)}:00`
    );

    // Prevent disabling booked times
    const attemptedBooked = selectedSlots.filter(slot => bookedSlots.includes(toMilitaryTime(slot.start.hour, slot.start.minute)));
    if (attemptedBooked.length > 0) {
      const list = attemptedBooked.map(s => toMilitaryTime(s.start.hour, s.start.minute)).join(', ');
      alert(`Cannot disable booked appointment time(s): ${list}`);
      return;
    }

    try {
      await postDisableTimes(dateTimes);
      alert('Time slots disabled successfully.');
      setSelectedSlots([]); // <-- Reset selectedSlots so green does not show
      fetchDisabledSlots(selectedDate);
      fetchHolidaySlots(selectedDate);
    } catch (error) {
      console.error('Error disabling time slots:', error);
      alert('Error disabling time slots');
    }
  };
  
  // Get today's date in YYYY-MM-DD format for minimum date constraint
  const today = new Date().toISOString().split('T')[0];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Time Block Booking</h2>
      
      <div style={styles.datePickerContainer}>
        <label style={styles.label}>Select Date:</label>
        <input type="date" min={today} value={selectedDate} onChange={handleDateChange} style={styles.dateInput} />
      </div>

      <div style={styles.timeSlotsContainer}>
        <h3 style={styles.subTitle}>Available Time Slots</h3>
        <div style={styles.slotsGrid}>
        {timeSlots.map((slot, index) => {
          const slotDateTime = `${selectedDate}T${toMilitaryTime(slot.start.hour, slot.start.minute)}:00`;
          const slotHolidayFormat = `${selectedDate.split('-').reverse().join('-')} ${toMilitaryTime(slot.start.hour, slot.start.minute)}`; // 'DD-MM-YYYY HH:mm'
          const holidayObj = holidaySlots.find(h => h.LeaveDate === slotHolidayFormat);
          const isDisabled = disabledSlots.includes(slotDateTime);
          const isHoliday = !!holidayObj;
          const isSelectedHoliday = isHoliday && selectedHolidayUids.includes(holidayObj?.Uid);
          const slotHHMM = toMilitaryTime(slot.start.hour, slot.start.minute);
          const isBooked = bookedSlots.includes(slotHHMM);

          return (
            <button
              key={index}
              onClick={() => {
                if (isHoliday) {
                  setSelectedHolidayUids((prev) =>
                    prev.includes(holidayObj.Uid)
                      ? prev.filter(uid => uid !== holidayObj.Uid)
                      : [...prev, holidayObj.Uid]
                  );
                } else if (!isBooked) { // do not allow selecting booked appointments
                  handleSlotToggle(slot);
                }
              }}
              style={{
                ...styles.timeSlotButton,
                backgroundColor: isSelectedHoliday
                  ? '#f44336' // red for selected holiday
                  : selectedSlots.some((s) => s.start.hour === slot.start.hour && s.start.minute === slot.start.minute)
                    ? '#4CAF50'
                    : isBooked
                      ? '#d3d3d3' // grey for booked appointment (cannot disable)
                      : isDisabled
                        ? '#f44336'
                        : isHoliday
                          ? '#dfbd69'
                          : '#f0f0f0',
                color: isSelectedHoliday
                  ? '#fff'
                  : selectedSlots.some((s) => s.start.hour === slot.start.hour && s.start.minute === slot.start.minute) || isDisabled || isHoliday || isBooked
                    ? '#000'
                    : '#333',
                border: isHoliday ? '2px solid #bfa100' : 'none',
                position: 'relative'
              }}
              disabled={isBooked} // block if booked; keep holidays selectable; disabledSlots show but selectable
            >
              {formatTime(slot.start.hour, slot.start.minute)} - {formatTime(slot.end.hour, slot.end.minute)}
              {isSelectedHoliday && (
                <span
                  style={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    fontSize: '16px',
                    color: 'red',
                    fontWeight: 'bold'
                  }}
                  title="Selected for deletion"
                >
                  ●
                </span>
              )}
              {isBooked && (
                <span
                  style={{
                    position: 'absolute',
                    bottom: 5,
                    right: 5,
                    fontSize: '10px',
                    color: '#444',
                    fontWeight: 'bold'
                  }}
                  title="Booked appointment"
                >Booked</span>
              )}
            </button>
          );
        })}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
      <button onClick={handleSubmit} style={styles.submitButton}>
        Submit Request
      </button>
      <button
        onClick={() => {
          if (selectedHolidayUids.length > 0) {
            deleteHolidayTimes(selectedHolidayUids);
            setSelectedHolidayUids([]);
          } else {
            alert('Select one or more gold slots to delete.');
          }
        }}
        style={{
          ...styles.submitButton,
          backgroundColor: 'red',
          color: '#fff'
        }}
      >
        Delete Holiday Time(s)
      </button>
    </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    textAlign: 'center',
    fontSize: '24px',
    marginBottom: '20px',
  },
  datePickerContainer: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '10px',
  },
  dateInput: {
    padding: '10px',
    width: '100%',
    fontSize: '16px',
  },
  timeSlotsContainer: {
    marginBottom: '20px',
  },
  subTitle: {
    fontSize: '20px',
    marginBottom: '10px',
  },
  slotsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: '10px',
  },
  timeSlotButton: {
    padding: '10px',
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '5px',
    border: 'none',
  },
  submitButton: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#007BFF',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    width: '100%',
    cursor: 'pointer',
  },
};

export default TimeBlockPage;
